import Spinner from 'vue-simple-spinner'

export default {
  data: () => ({
    loading: false
  }),

  components: {
    'spinner': Spinner
  }
}
